import { Component, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { CountryService, Country } from 'src/app/acumatica/EntityServices/Country.service';

@Component({
  selector: 'country-selector',
  templateUrl: './country-selector.component.html',
  styleUrls: ['./country-selector.component.css'],
})
export class CountrySelectorComponent implements OnInit {
  countryInput = new FormControl();
  countries: Country[] = [];

  constructor(
    private countryService: CountryService
  ) { }

  ngOnInit(): void {
    let countries = localStorage.getItem('countries-list');
    if (countries == null) {
      this.countryService.getCountries({ loader: null }).subscribe(countries => {
        localStorage.setItem('countries-list', JSON.stringify(countries));
        this.countries = countries;
      });
    }
    else {
      this.countries = JSON.parse(countries).map((country: any) => new Country(country));
    }
  }

  displayFn(country: Country): string { return country && country.toString(); }
}
